import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import useLogout from 'hooks/useLogout';
import { useEffect } from 'react';
import { addUnauthorizedInterceptor } from 'services/api';
import {
  decodeToken,
  isTokenAuthenticated,
  loadTokenFromStorage,
} from 'utils/token';
import { CallableRoot } from '../CallableRoot';

export const Route = createRootRoute({
  beforeLoad: ({ matches }) => {
    // If no route besides the root route matches, we redirect either to the 404 page or the login page,
    // depending on whether or not to user is logged in
    const matched = matches.length > 1;
    if (!matched) {
      const token = loadTokenFromStorage();
      if (isTokenAuthenticated(decodeToken(token))) {
        throw redirect({
          to: '/products',
        });
      } else {
        throw redirect({
          to: '/auth/login',
        });
      }
    }
  },
  component: Root,
});

function Root() {
  const logout = useLogout();

  useEffect(() => {
    addUnauthorizedInterceptor(() => {
      logout();
    });
  }, [logout]);

  return (
    <>
      <Outlet />
      <CallableRoot />
    </>
  );
}
